// Photo uploader for Flohmarkt ads and Mitteilungen: each photo uploads at once with real progress, can be
// removed and moved; the first one is the title picture. The parent sends `photos.payload()` with the form.
import { MAX_PHOTOS, type usePhotos } from './usePhotos';
import { Icon } from './ui';

export function PhotoUploader({ photos, label }: { photos: ReturnType<typeof usePhotos>; label: string }) {
  const { tiles, addFiles, remove, move } = photos;
  return (
    <div className="fl">
      <span>{label}</span>
      <div className="uploader">
        {tiles.map((t, i) => (
          <div
            key={t.key}
            className={`up-item${t.progress !== undefined ? ' is-pending' : ''}`}
            aria-busy={t.progress !== undefined}
          >
            <img src={t.src} alt="" />
            {t.progress !== undefined && (
              <span className="up-busy">
                <i className="spin" />
                {t.progress < 100 ? `${t.progress} %` : 'Wird verarbeitet …'}
              </span>
            )}
            {i === 0 && t.progress === undefined && <span className="first">Titelbild</span>}
            <button type="button" onClick={() => remove(t.key)} aria-label="Foto entfernen">
              <Icon name="x" sw={2.2} />
            </button>
            {t.progress === undefined && tiles.length > 1 && (
              <span className="up-move">
                {i > 0 && (
                  <button type="button" onClick={() => move(i, -1)} aria-label="Foto nach vorne">
                    <Icon name="left" sw={2.2} />
                  </button>
                )}
                {i < tiles.length - 1 && (
                  <button type="button" onClick={() => move(i, 1)} aria-label="Foto nach hinten">
                    <Icon name="right" sw={2.2} />
                  </button>
                )}
              </span>
            )}
          </div>
        ))}
        {tiles.length < MAX_PHOTOS && (
          <label
            className="up-add"
            onDragOver={e => e.preventDefault()}
            onDrop={e => {
              e.preventDefault();
              addFiles(e.dataTransfer.files);
            }}
          >
            <Icon name="cam" sw={1.5} />
            Foto hinzufügen
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={e => {
                if (e.target.files) addFiles(e.target.files);
                e.target.value = '';
              }}
              aria-label="Foto hinzufügen"
            />
          </label>
        )}
      </div>
    </div>
  );
}
